/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ThresholdConfig } from './ThresholdConfig';
import {
    ThresholdConfigFromJSON,
    ThresholdConfigFromJSONTyped,
    ThresholdConfigToJSON,
    ThresholdConfigToJSONTyped,
} from './ThresholdConfig';

/**
 * 
 * @export
 * @interface SectionItem
 */
export interface SectionItem {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    question?: string;
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    sectionType?: SectionItemSectionTypeEnum;
    /**
     * 
     */
    required?: boolean;
    /**
     * 
     */
    order?: number;
    /**
     * 
     */
    guidanceImageUrl?: string;
    /**
     * 
     */
    machinePartId?: string;
    /**
     * 
     */
    measurementKey?: string;
    /**
     * 
     */
    thresholds?: ThresholdConfig;
    /**
     * 
     */
    expectedReadingCount?: number;
    /**
     * 
     */
    subFieldLabels?: Array<string>;
    /**
     * 
     */
    computeAverage?: boolean;
}


/**
 * @export
 */
export const SectionItemSectionTypeEnum = {
    StatusCheck: 'STATUS_CHECK',
    NumberEntry: 'NUMBER_ENTRY',
    TextResult: 'TEXT_RESULT',
    MultiValue: 'MULTI_VALUE',
} as const;
export type SectionItemSectionTypeEnum = typeof SectionItemSectionTypeEnum[keyof typeof SectionItemSectionTypeEnum];


/**
 * Check if a given object implements the SectionItem interface.
 */
export function instanceOfSectionItem(value: object): value is SectionItem {
    return true;
}

export function SectionItemFromJSON(json: any): SectionItem {
    return SectionItemFromJSONTyped(json, false);
}

export function SectionItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'question': json['question'] == null ? undefined : json['question'],
        'description': json['description'] == null ? undefined : json['description'],
        'sectionType': json['sectionType'] == null ? undefined : json['sectionType'],
        'required': json['required'] == null ? undefined : json['required'],
        'order': json['order'] == null ? undefined : json['order'],
        'guidanceImageUrl': json['guidanceImageUrl'] == null ? undefined : json['guidanceImageUrl'],
        'machinePartId': json['machinePartId'] == null ? undefined : json['machinePartId'],
        'measurementKey': json['measurementKey'] == null ? undefined : json['measurementKey'],
        'thresholds': json['thresholds'] == null ? undefined : ThresholdConfigFromJSON(json['thresholds']),
        'expectedReadingCount': json['expectedReadingCount'] == null ? undefined : json['expectedReadingCount'],
        'subFieldLabels': json['subFieldLabels'] == null ? undefined : json['subFieldLabels'],
        'computeAverage': json['computeAverage'] == null ? undefined : json['computeAverage'],
    };
}

export function SectionItemToJSON(json: any): SectionItem {
    return SectionItemToJSONTyped(json, false);
}

export function SectionItemToJSONTyped(value?: SectionItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'question': value['question'],
        'description': value['description'],
        'sectionType': value['sectionType'],
        'required': value['required'],
        'order': value['order'],
        'guidanceImageUrl': value['guidanceImageUrl'],
        'machinePartId': value['machinePartId'],
        'measurementKey': value['measurementKey'],
        'thresholds': ThresholdConfigToJSON(value['thresholds']),
        'expectedReadingCount': value['expectedReadingCount'],
        'subFieldLabels': value['subFieldLabels'],
        'computeAverage': value['computeAverage'],
    };
}

